const TableWrap = () => {
    var wrap = (els, tag) => {
      document.querySelectorAll(els).forEach(el => {
        const div = document.createElement(tag);
        div.classList.add('table-responsive')
        el.parentElement.insertBefore(div, el);
        div.appendChild(el);
      });
    };
  
    wrap('table', 'div');
  };
  export default TableWrap;
  